import { resolveNotificationRoute } from "@/utils/notification";

/**
 * Portal route for a notification action payload.
 * @param {object} notification
 * @returns {string|null}
 */
export function portalNotificationRoute(notification) {
  return resolveNotificationRoute(notification, {
    ticket(action) {
      return `/tickets/${action.ticket_number}`;
    },
    consultation(action, n) {
      const id = action.consultation_id;
      switch (action.screen) {
        case "chat":
          return `/consultations/${id}/chat`;
        case "offer":
          return `/consultations/${id}`;
        case "invoice":
          return `/consultations/${id}`;
        case "response":
          return `/consultations/${id}`;
        default:
          if (n.category === "negotiation") {
            return `/consultations/${id}/negotiations`;
          }
          return `/consultations/${id}`;
      }
    },
  });
}
